import React from 'react';
import { useRecoilState } from 'recoil';
import { OrderPayload } from 'pages/reference-implementation/provisioning/RI003AWS/store';
import { FormControl, FormControlLabel, Grid, Typography } from '@mui/material';
import FormCard from 'pages/reference-implementation/components/form-card';
import riStyle, { CustomRadioGroup, CustomRadio } from 'pages/reference-implementation/Style';
import MyCertADGroupOwner from './MyCertADGroupOwner';
import { ADCertGroup } from './ADCertGroup';

const MyCertADGroup = () => {
    const [order, setOrder] = useRecoilState(OrderPayload);

    const setMyCertADGroup = (myCertADGroup) => {
        setOrder({
            ...order,
            myCertADGroup,
            adCertGroup: null,
            myCertADGroupOwner: null,
            myCertADGroupOwnerDetails: null,
        });
    };

    const handleOnSelectChange = (selected) => {
        setMyCertADGroup(selected);
    };
    return (
        <FormCard title="Access Management">
            <Grid container spacing={1}>
                <Grid item xs={12} sm={12}>
                    <Typography sx={riStyle?.form?.accessMgmt?.heading}>ACTIVE DIRECTORY CERTIFICATE GROUP</Typography>
                    <Typography my="10px" sx={riStyle?.form?.accessMgmt?.label}>
                        Do you have an Active Directory Certificate Group <span style={{ color: 'red' }}>*</span>
                    </Typography>
                    <FormControl data-testid="my-cert-radio-box">
                        <CustomRadioGroup
                            aria-label="myCertADGroupADGroup"
                            name="myCertADGroupadgroupRadioBtnGroup"
                            row
                            value={order?.myCertADGroup || null}
                            onChange={(event, value) => handleOnSelectChange(value)}
                        >
                            <FormControlLabel value="Yes" control={<CustomRadio />} label="Yes, I do" />
                            <FormControlLabel
                                value="No"
                                sx={{
                                    marginLeft: '60px',
                                }}
                                control={<CustomRadio />}
                                label="No, I don't"
                            />
                        </CustomRadioGroup>
                    </FormControl>
                </Grid>
                {order?.myCertADGroup === 'Yes' && (
                    <Grid item xs={12} sm={6}>
                        <ADCertGroup />
                    </Grid>
                )}
                {order?.myCertADGroup === 'No' && (
                    <Grid item xs={12} sm={6}>
                        <MyCertADGroupOwner />
                    </Grid>
                )}
            </Grid>
        </FormCard>
    );
};

export default MyCertADGroup;
